import React, { useState } from 'react';



export type SidebarContextType = {
    showingSidebar: boolean,
    setShowingSidebar?: (sidebar: boolean) => void;
    showingRegularSidebar: boolean,
    setShowingRegularSidebar?: (sidebar: boolean) => void;
}

export const SidebarContext = React.createContext<SidebarContextType>({
    showingSidebar: false,
    setShowingSidebar: () => { throw "not implemented" },
    showingRegularSidebar: true,
    setShowingRegularSidebar: () => { throw "not implemented" },
});

export const SidebarProvider = function({ children }: { children: React.ReactNode })  {
    const [showingSidebar, setShowingSidebarState] = useState(false);
    const [showingRegularSidebar, setShowingRegularSidebarState] = useState(true);
    //    const [loaded, setLoaded] = useState(false);

    // useEffect(() => {
    //     if(!loaded) {
    //         setLoaded(true);
    //         localforage.getItem<boolean>(FORAGE_KEY).
    //             then((data) => {
    //                 setSunrise(data || false);
    //             });
    //     }
    // }, [loaded, setLoaded]);


    function setShowingSidebar(sidebar: boolean) {
        setShowingSidebarState(sidebar);
    }

    function setShowingRegularSidebar(sidebar: boolean) {
        setShowingRegularSidebarState(sidebar);
    }
    const data = {
        showingSidebar: showingSidebar,
        setShowingSidebar: setShowingSidebar,
        showingRegularSidebar: showingRegularSidebar,
        setShowingRegularSidebar: setShowingRegularSidebar,
    };

    return (
        <SidebarContext.Provider value={data}>{ children }</SidebarContext.Provider>
    );

};
